import React from "react";
import { Helmet } from "react-helmet-async";

const SEO = ({
  title = "Heritage Car Taxi | 24/7 Airport & City Rides | CALL OR TEXT NOW +19142762961",
  description = "Heritage Car Taxi (NY DOS ID #7502116). Safe, fast, and reliable airport transfers & city rides.",
  url = "https://heritagecarairport.com",
  image = "https://heritage-car-airport.vercel.app/home-image.jpg",
}) => {
  const extendedKeywords = [
    "Taxi in Yorktown Heights",
    "Taxi service in Yorktown Heights",
    "Taxi near me in Yorktown Heights",
    "24-hour taxi in Yorktown Heights",
    "Fast and safe taxi in Yorktown Heights",
    "Reliable taxi service in Yorktown Heights",
    "Cheap taxi in Yorktown Heights",
    "Private taxi in Yorktown Heights",
    "Book a taxi in Yorktown Heights",
    "Long-distance taxi in Yorktown Heights",
    "Taxi from Yorktown Heights to New York City",
    "Taxi from Yorktown Heights to Manhattan",
    "Taxi from Yorktown Heights to Brooklyn",
    "Taxi from Yorktown Heights to the Bronx",
    "Taxi from Yorktown Heights to Queens",
    "Taxi from Yorktown Heights to Staten Island",
    "Taxi from Yorktown Heights to White Plains",
    "Taxi from Yorktown Heights to Westchester",
    "Taxi from Yorktown Heights to Connecticut",
    "Taxi from Yorktown Heights to New Jersey",
    "Corporate taxi in Yorktown Heights",
    "Executive transportation in Yorktown Heights",
    "Luxury taxi in Yorktown Heights",
    "Car rental with driver in Yorktown Heights",
    "Airport taxi from Yorktown Heights",
    "Taxi from Yorktown Heights to JFK",
    "Taxi from Yorktown Heights to LaGuardia",
    "Taxi from Yorktown Heights to Newark",
    "Taxi from Yorktown Heights to Stewart International Airport",
    "Airport transfer from Yorktown Heights",
    "Trusted taxi in Yorktown Heights",
    "24/7 taxi service in Yorktown Heights",
    "Affordable taxi in Yorktown Heights",
    "Car service in Yorktown Heights",
    "Taxi for events in Yorktown Heights",
    "Safe taxi in Yorktown Heights",
    "Transportation service in Yorktown Heights"
  ];

  const keywordsString = extendedKeywords.join(", ");

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Heritage Car Airport",
    "url": url,
    "description": description,
    "telephone": "+1-914-276-2961",
    "image": image,
    "hasMap": "https://www.google.com/maps/place/Heritage+Car+Service/@41.4763134,-73.7414121",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "395 Hallocks Mill RD",
      "addressLocality": "Yorktown Heights",
      "addressRegion": "NY",
      "postalCode": "10598",
      "addressCountry": "US"
    },
    "serviceProvided": [
      { "name": "Corporate Events" },
      { "name": "Airport Rides" },
      { "name": "Local Rides" },
      { "name": "Luxury Rides" },
      { "name": "Long Distance" },
      { "name": "Weddings" },
      { "name": "Proms" },
      { "name": "City Tours" },
      { "name": "Wine Tours" },
      { "name": "Cruise Port Transfers" },
      { "name": "Business Meetings" },
      { "name": "VIP Transportation" },
      { "name": "Night Outs" },
      { "name": "Casino Trips" },
      { "name": "Quinceañeras" },
      { "name": "Anniversaries" },
      { "name": "Birthday Parties" },
      { "name": "Road Shows" },
      { "name": "Sporting Events" },
      { "name": "Executive Services" }
    ]
  };

  const vehicles = [
    {
      name: "Cadillac XTS",
      description: "Para hasta 4 pasajeros, Heritage Car Airports ofrece un servicio de taxi elegante y rápido, perfecto para viajes locales o traslados al aeropuerto. Disponible 24/7."
    },
    {
      name: "Lincoln MKT",
      description: "Viaja con estilo con el Lincoln MKT, con capacidad para hasta 5 pasajeros. Servicio rápido y cómodo para negocios o placer. Disponible 24/7."
    },
    {
      name: "Cadillac Escalade",
      description: "Espacioso y lujoso, ideal para grupos de hasta 7 personas. Heritage Car Airports ofrece traslados premium y puntuales. Disponible 24/7."
    },
    {
      name: "Mercedes Sprinter",
      description: "Ideal para grupos grandes, transporta hasta 15 pasajeros. Servicio seguro y oportuno, perfecto para eventos y viajes en grupo. Disponible 24/7."
    }
  ];

  const structuredVehicles = vehicles.map((v) => ({
    "@context": "https://schema.org",
    "@type": "Product",
    "name": v.name,
    "description": v.description,
    "brand": "Heritage Car Airport",
    "offers": {
      "@type": "Offer",
      "availability": "https://schema.org/InStock",
      "price": "0.00",
      "priceCurrency": "USD"
    }
  }));

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywordsString} />
      <meta name="robots" content="index, follow" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>
      {structuredVehicles.map((vehicle, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(vehicle)}
        </script>
      ))}
    </Helmet>
  );
};

export default SEO;
